
export const environment = {
    production: false,
    authApiUrl: 'https://dev.trader.win/api',
    apiURL: 'https://dev.trader.win/api',
    baseUrl: 'https://dev.trader.win',
    filesApiUrl: 'https://dev.trader.win/api',
};
